import { render, staticRenderFns } from "./TypeLabel.vue?vue&type=template&id=55ddca1a&scoped=true&"
import script from "./TypeLabel.vue?vue&type=script&lang=ts&"
export * from "./TypeLabel.vue?vue&type=script&lang=ts&"
import style0 from "./TypeLabel.vue?vue&type=style&index=0&id=55ddca1a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ddca1a",
  null
  
)

export default component.exports